import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import AdminTable from "../Administrator/Helpers/AdminTable";
import { commentsAction } from "src/store/Slices/ClientsSlice";
import SureModal from "src/components/Modals/SureModal";
import EditComment from "./Modals/EditComment";
import dayjs from "dayjs";
import { Switch } from "antd";
import { getClientsList } from "src/store/Slices/ClientsSlice";
const ClientsComments = ({
  clientInfo,
  title,
  page,
  pageSize,
  setPage,
  setPageSize,
  mnemo,
  commentInfo,
  setCommentInfo,
  payload,
}) => {
  const dispatch = useDispatch();
  const items = [
    {
      key: "1",
      label: "Редактировать",
      onClick: () => {
        setIsOpenEditModal(true);
      },
      disabled: !mnemo?.children?.find((el) => el.mnemo === "updateBtn"),
    },
    {
      key: "2",
      label: "Удалить",
      onClick: () => {
        setOpenDeliteAbonementModal(true);
      },
      disabled: !mnemo?.children?.find((el) => el.mnemo === "deleteBtn"),
    },
  ];
  const [isOpenEditModal, setIsOpenEditModal] = useState(false);
  const [openDeliteAbonementModal, setOpenDeliteAbonementModal] =
    useState(false);

  // STORE
  const commentsList = useSelector((state) => state.ClientsSlice.commentsList);
  const commentsListLoading = useSelector(
    (state) => state.ClientsSlice.commentsListLoading
  );

  const searchItemsMap = (keys, values) => {
    const formattedItems = {};
    if (keys && values) {
      keys.forEach((key, index) => {
        if (values[index] != undefined && values[index][0] != undefined) {
          if (key === "contactDate") {
            formattedItems["ContactDate.From"] = dayjs(values[index][0]).format(
              "YYYY-MM-DD"
            );
            formattedItems["ContactDate.To"] = dayjs(values[index][1]).format(
              "YYYY-MM-DD"
            );
          } else if (key === "price") {
            formattedItems["Price.From"] = values[index][0];
            formattedItems["Price.To"] = values[index][1];
          } else if (key === "task") {
            formattedItems["task.From"] = dayjs(values[index][0]).format(
              "YYYY-MM-DD"
            );
            formattedItems["task.To"] = dayjs(values[index][1]).format(
              "YYYY-MM-DD"
            );
          } else {
            formattedItems[key] = values[index][0];
          }
        }
      });
      return formattedItems;
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const payload = searchItemsMap(
      Object.keys(filters),
      Object.values(filters)
    );
    dispatch(
      commentsAction({
        flag: "get",
        value: {
          UserId: clientInfo?.id,
          count: pagination.pageSize,
          offset: pagination.pageSize * (pagination.current - 1),
          orderBy: sorter?.column?.dataIndex,
          isDesc: sorter.order
            ? sorter.order === "ascend"
              ? true
              : false
            : undefined,
          ...payload,
        },
      })
    );
    setPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  const onClickRowOne = (record) => {
    setCommentInfo(record);
  };

  const onClickYesDeleteComment = () => {
    dispatch(
      commentsAction({
        flag: "delete",
        value: {
          Id: commentInfo?.id,
        },
      })
    ).then(() => {
      dispatch(
        commentsAction({ flag: "get", value: { UserId: clientInfo?.id } })
      );
      dispatch(getClientsList());
      setOpenDeliteAbonementModal(false);
    });
  };

  const handleComplete = (commentInfo) => {
    dispatch(
      commentsAction({
        flag: "post",
        value: {
          id: commentInfo?.id,
          isCompleted: !commentInfo?.isCompleted,
        },
      })
    ).then(() => {
      dispatch(
        commentsAction({ flag: "get", value: { UserId: clientInfo?.id } })
      );
      dispatch(getClientsList(payload));
    });
  };

  const formatedCommentsRows = commentsList?.data?.value?.rows.map(
    (element) => {
      return {
        ...element,
        isCompleted: element?.isCompleted != null && (
          <Switch
            onClick={() => {
              setCommentInfo(element);
              handleComplete(element);
            }}
            defaultChecked
            value={element?.isCompleted}
          />
        ),
      };
    }
  );
  console.log("commentList", commentsList);
  return (
    <>
      <SureModal
        visible={openDeliteAbonementModal}
        setVisible={setOpenDeliteAbonementModal}
        onClickYes={onClickYesDeleteComment}
      />
      <EditComment
        commentModal={isOpenEditModal}
        setCommentModal={setIsOpenEditModal}
        clientInfo={clientInfo}
        commentInfo={commentInfo}
        payload={payload}
      />
      {window.innerWidth >= 768 && (
        <AdminTable
          scroll={{ x: 0, y: 200 }}
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          onChange={handleTableChange}
          loading={commentsListLoading}
          onClickRowOne={onClickRowOne}
          columns={commentsList}
          rows={formatedCommentsRows}
          total={commentsList?.data?.value?.totalCount}
          title={title}
          items={items}
        />
      )}
    </>
  );
};

export default ClientsComments;
